<template>
	<div
		class="tw-flex tw-justify-between tw-items-center p-dialog-header tw-py-4 tw-px-6"
		:style="{ margin: negativeMargin ? '-20px -20px 0' : 'auto' }"
	>
		<h3 class="tw-text-app-color-secondary"><slot></slot>
			
		</h3>
		<div class="tw-flex tw-items-left" style="width: 50%;">
			<button
				v-if="search"
				v-show="!showInput"
				class="btn"
				@click="toggleSearch"
			>
				<img
					:src="`${$imageUrl}/magnifying-glass.svg`"
					alt="Buscador"
					height="15"
					width="15"
				/>
			</button>
			<input
				v-show="showInput"
				v-model="searchText"
				type="text"
				placeholder="Buscar..."
				class="p-dialog-header-input"
				@keyup.enter="performSearch"
				@blur="hideSearchInput"
			/>
		</div>
		<close-icon class="cursor-pointer" @click="$emit('closeClicked')"></close-icon>
	</div>
</template>
<script>
import CloseIcon from '@/modules/shared/components/icons/close-icon';

function created() {
}

export default {
	components: { CloseIcon },
	name: 'p-header-dialog',
	created,
	data() {
		return {
			showInput: false,
			searchText: '',
		};
	},
	methods: {
		toggleSearch() {
			this.showInput = true;
		},
		performSearch() {
			this.$emit('on-search', this.searchText);
			this.searchText = '';
			this.hideSearchInput();
		},
		hideSearchInput() {
			this.showInput = false;
		},
	},
	props: {
		negativeMargin: {
			default: true,
		},
		search: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped lang="scss">
.p-dialog-header {
	background-color: var(--app-color-gray-white);
	border-bottom: 1px solid var(--app-color-gray);
	border-top: 1px solid var(--app-color-gray);
	.btn {
		border-radius: 50%;
		background-color: color(green-dark);
		margin-left: 12px;
		padding: 5px 8px 1px 6px;
	}
	&-input {
		background: map-get($colors, white);
		border: 1px solid color(green-dark);
		border-radius: 6px;
        display: block;
        outline: none;
		color: color(green-dark);
		margin-top: 0;
		padding: 2px 20px;
		width: 100%;

		&::placeholder {
			color: map-get($colors, placeholder);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/content/p-header-dialog.vue